import _ from "lodash";
import UserService from "../user/UserService";
import UserSearch from "@/modules/setup/user/models/UserSearch.model";
import i18n from "@/shared/i18n";

let getDefaultTableData = () => ({
  loading: false,
  rows: [],
  pagination: {
    limit: 50,
    page: 1,
    total: 0,
  },
  ordering: '-created_at',
  searchModel: new UserSearch(),
  tableFields: [
    {
      key: "first_name",
      label: i18n.t("Full Name"),
      sortable: true
    },
    {
      key: "email",
      label: i18n.t("Email"),
      sortable: true
    },
    {
      key: "branch_uuid",
      label: i18n.t("Branch"),
      sortable: false
    },
    {
      key: "is_blocked",
      label: i18n.t("Blocked"),
      sortable: true
    },
    {
      key: "last_login",
      label: i18n.t("Last Logged In"),
      sortable: true
    },
    {
      key: "device",
      label: i18n.t("Device Info"),
      sortable: false
    },
    {
      key: "title",
      label: i18n.t("Title"),
      sortable: false
    },
    {
      key: "department",
      label: i18n.t("Department"),
      sortable: false
    },
    {
      key: "address",
      label: i18n.t("Address"),
      sortable: false
    },
    {
      key: "actions",
      label: i18n.t('Actions'),
      sortable: false
    },
  ]
})

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null
    },
    tableData: getDefaultTableData(),
  },
  actions: {
    showModal({commit}, object = null) {
      commit('showModal', _.cloneDeep(object));
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await UserService.getUsers(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
        });
      }

      return response;
    },
    getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData;

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: currentTableData.ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      data.expand = 'permissions,branch,branches,device,country';

      return data;
    },

    async createUser({dispatch}, user) {
      let response = await UserService.createUser(user);

      if (response.success) {
        dispatch('getTableData');
      }

      return response;
    },
    async updateUser({commit}, user) {
      let response = await UserService.updateUser(user.uuid, user);
      if (response.success) {
        commit('updateUser', response.body);
      }
      return response;
    },
    async removeUser({commit, dispatch, state}, user) {
      let response = await UserService.removeUser(user.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    updateSearchModel({commit, state}, {searchModel}) {
      commit('updateSearchModel', {
        searchModel: new UserSearch({
          ...state.tableData.searchModel,
          ...searchModel
        })
      });
    },
    resetSearchModel({commit}) {
      commit('resetSearchModel')
    },
    async resetTable({state, dispatch}) {
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData.pagination.limit;
      state.tableData = defaultTableData;
      dispatch('getTableData');
    },
    resetTableDataPaginationPage({state}) {
      state.tableData.pagination.page = 1;
    },
  },
  mutations: {
    showModal: (state, object) => {
      state.modal.show = true;
      state.modal.object = object;
    },
    hideModal: state => state.modal.show = false,
    updateTableData: (state, payload) => state.tableData = {...state.tableData, ...payload},
    updateUser: (state, user) => {
      const index = state.tableData.rows.findIndex(u => u.uuid === user.uuid);
      state.tableData.rows[index] = {...state.tableData.rows[index], ...user};
      state.tableData.rows = [...state.tableData.rows];
    },
    updateTableLoading: (state, payload) => state.tableData.loading = payload,
    updateSearchModel: (state, {
      searchModel
    }) => state.tableData.searchModel = searchModel,
    resetSearchModel: state => {
      state.tableData.searchModel = new UserSearch()
    },
  }
};
